//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  componentNameToTemplate,
  lazyLoadModule,
  NavGroup,
  StateFactory,
} from 'app/initialization/routing/stateHelpers';

export const states = {
  'instagram-comment-export': StateFactory({
    url: '/comment-export/:exportId',
    template: componentNameToTemplate('instagramCommentExport'),
    data: {
      title: 'Comment Export',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.app',
        () => import('app/email-exports/comments.app'),
      ),
    },
  }),

  'instagram-post-performance-export': StateFactory({
    url: '/email-exports/:exportId',
    template: componentNameToTemplate('instagramPostPerformanceExport'),
    data: {
      title: 'Post Performance Exports',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.app',
        () => import('app/email-exports/post-performance.app'),
      ),
    },
  }),
};
